/** biome-ignore-all lint/correctness/useUniqueElementIds: Mye enklere å holde orden på lenkene enn masse variabler? */
import { Heading, Paragraph } from "@digdir/designsystemet-react";
import { Page } from "@/components";
import { formatDate } from "@/utils/dateTimeUtils";

export const VilkårPage = () => {
  // Vilkår siden er gjengitt direkte slik de er i vilkårene og er ikke oversatt.
  return (
    <main className="container mx-auto grid grid-cols-1 xl:grid-cols-[1fr_auto] py-14 gap-6 gap-x-12 max-w-page">
      <Page
        withBackLink
        className="flex flex-col gap-4 leading-9 max-w-4xl! mx-0"
      >
        <Heading level={1} data-size="xl" className="mb-6 text-3xl md:text-5xl">
          Vilkår for bruk av selskapsportal for fjernvarme
        </Heading>
        <section className="max-w-card flex flex-col gap-6">
          <Paragraph>Dagens dato {formatDate(new Date())}</Paragraph>

          <Paragraph className="whitespace-pre-line">Kommer...</Paragraph>
        </section>
      </Page>
    </main>
  );
};
